import React, { useState, useEffect } from 'react';
import './Daily_income.scss';
import moment from "moment";
import axios from 'axios';
import APP_BASE_URL from "../../components/Api/globalApi";

const WithdrawHistory = ({ page = 1, searchQuery = "" }) => {
    const [data, setData] = useState([]);
    const [itemsPerPage] = useState(10);

    const fetchWithdrawHistory = async () => {
        const user_id = localStorage.getItem("user_id");
        const user_api = localStorage.getItem("user_api");

        try {
            const response = await axios.post(
                `${APP_BASE_URL}/user/withdraw/history`,
                {
                    income_type: "incentive"
                },
                {
                    headers: {
                        user_id: user_id,
                        api_key: user_api,
                    },
                }
            );

            if (response.data?.result === true && Array.isArray(response.data.data)) {
                setData(response.data.data);
            } else {
                console.warn("Unexpected API response:", response.data);
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching withdrawal history:", error);
            setData([]);
        }
    };

    useEffect(() => {
        fetchWithdrawHistory();
    }, [page, searchQuery]);

    return (
        <div className="container-fluid myprofile py-5">
            <h4 className="text-white">Withdraw History</h4>
            <div className="table-responsive mt-4">
                <table className="table table-light table-hover shadow">
                    <thead>
                        <tr>
                            <th scope="col">Sl no</th>
                            <th scope="col">Income Received</th>

                            <th scope="col">Status</th>
                            <th scope="col">Date</th>
                            <th scope="col">Approved Date</th>
                            <th scope="col">Income Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((details, index) => (
                                <tr key={index}>
                                    <th scope="row">{index + 1}</th>
                                    <td>{details.n_amount}</td>
                                    <td>{details.n_status}</td>
                                    <td>{moment(details.n_date).format("DD MMM YYYY")}</td>
                                    <td><center>{details.n_status === 'approved' ? moment(details.n_approve_date).format("DD MMM YYYY") : '-'}</center></td>
                                    <td>{details.n_type || "Withdraw"}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">No data available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default WithdrawHistory;
